const Bugtracker = {
  notify: (err, options) => {
    if (typeof Bugsnag !== 'undefined') {
      //eslint-disable-next-line no-undef
      Bugsnag.notify(err, options)
    } else {
      console.warn('[No Bugsnag Client] Debug Error:', err, options)
    }
  }
}

export default Bugtracker
